<template>
  <button class="back-btn">
    <svg-icon class="back-btn__arrow" :icon="arrow" :width="6" :height="10" />
    <slot></slot>
  </button>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon'
  import arrow from '@/assets/svg/arrow.svg'

  export default {
    components: {
      SvgIcon
    },
    data () {
      return {
        arrow
      }
    }
  }
</script>

<style lang="scss" scoped>
  .back-btn {
    @include naked-btn;
    padding: 0;
    color: #ffffff;
    font-size: rem(12);
    font-weight: bold;
    text-transform: uppercase;

    &:hover {
      color: color(yellow);
    }

    &__arrow {
      fill: currentColor;
      transform: rotateZ(180deg);
      margin-right: rem(4);
    }
  }
</style>



// WEBPACK FOOTER //
// BackButton.vue?015e9e32